<template>
  <div class="channel-page">
    <tableComponents
      ref="tableComponents"
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      :searchData="channelSearchData"
      :isHaveExport="false"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
      @toAdd="openCreateDialog"
    >
      <template #table>
        <el-table :data="pagedList" border stripe v-loading="loading">
          <el-table-column prop="id" label="ID" width="70" align="center" />
          <el-table-column label="APP" min-width="180">
            <template slot-scope="{ row }">
              <div class="channel-cell">
                <div class="channel-cell__title">
                  {{ row.app && row.app.app_name ? row.app.app_name : "--" }}
                </div>
                <div class="channel-cell__sub">
                  {{ row.app && row.app.app_code ? row.app.app_code : "--" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="渠道名称" min-width="180" />
          <el-table-column label="状态" width="110" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="Number(getChannelOpenStatus(row)) === 1 ? 'success' : 'info'">
                {{ Number(getChannelOpenStatus(row)) === 1 ? "开启" : "关闭" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="160" align="center">
            <template slot-scope="{ row }">
              {{ $fnc.getTimeFormat(row.created_time, "ymdhms") }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="280" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button size="mini" type="primary" plain @click="goDetail(row.id)">
                详情
              </el-button>
              <el-button size="mini" type="primary" plain @click="changeNickname(row)">
                修改
              </el-button>
              <el-button size="mini" type="warning" plain @click="copyChannel(row.id)">
                复制
              </el-button>
              <el-button size="mini" type="danger" plain @click="delChannel(row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </tableComponents>

    <el-dialog
      title="新增渠道"
      :visible.sync="dialogVisible"
      width="460px"
      @closed="resetDialog"
    >
      <el-form ref="channelFormRef" :model="channelForm" :rules="channelRules" label-width="90px">
        <el-form-item label="APP" prop="app_id">
          <el-select
            v-model="channelForm.app_id"
            placeholder="请选择 APP"
            clearable
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="item in appList"
              :key="item.id"
              :label="item.app_name || item.app_code"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="渠道名称" prop="nickname">
          <el-input v-model.trim="channelForm.nickname" placeholder="请输入渠道名称" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="addChannel">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { channelSearchData } from "@/assets/js/searchData";

export default {
  data() {
    return {
      channelSearchData,
      loading: false,
      saving: false,
      dialogVisible: false,
      list: [],
      filteredList: [],
      total: 0,
      queryForm: {},
      paginationForm: {
        page: 1,
        page_size: 10,
      },
      channelForm: {
        app_id: "",
        nickname: "",
      },
      channelRules: {
        app_id: [{ required: true, message: "请选择 APP", trigger: "change" }],
        nickname: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState({ appList: (state) => state.appList }),
    pagedList() {
      const start = (this.paginationForm.page - 1) * this.paginationForm.page_size;
      const end = start + this.paginationForm.page_size;
      return this.filteredList.slice(start, end);
    },
  },
  methods: {
    getChannelOpenStatus(row) {
      return row.channel_config && row.channel_config.is_open !== undefined
        ? row.channel_config.is_open
        : 0;
    },
    openCreateDialog() {
      this.dialogVisible = true;
    },
    resetDialog() {
      if (this.$refs.channelFormRef) {
        this.$refs.channelFormRef.resetFields();
      }
      this.channelForm = {
        app_id: "",
        nickname: "",
      };
      this.saving = false;
    },
    applyLocalFilters() {
      const keywordApp = (this.queryForm.app_name || "").trim().toLowerCase();
      const keywordNickname = (this.queryForm.nickname || "").trim().toLowerCase();
      const status = this.queryForm.is_open;

      this.filteredList = this.list.filter((item) => {
        const appName = item.app && item.app.app_name ? item.app.app_name.toLowerCase() : "";
        const appCode = item.app && item.app.app_code ? item.app.app_code.toLowerCase() : "";
        const nickname = item.nickname ? String(item.nickname).toLowerCase() : "";
        const openStatus = String(this.getChannelOpenStatus(item));

        const matchApp = !keywordApp || appName.includes(keywordApp) || appCode.includes(keywordApp);
        const matchNickname = !keywordNickname || nickname.includes(keywordNickname);
        const matchStatus = status === undefined || status === "" ? true : openStatus === String(status);

        return matchApp && matchNickname && matchStatus;
      });

      this.total = this.filteredList.length;
    },
    async getChannelList() {
      this.loading = true;
      try {
        const data = await this.$api.getChannel.getChannelList(this.queryForm);
        this.list = Array.isArray(data.data) ? data.data : [];
        this.applyLocalFilters();
      } finally {
        this.loading = false;
      }
    },
    async addChannel() {
      const valid = await new Promise((resolve) => {
        this.$refs.channelFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.saving = true;
      try {
        const data = await this.$api.getChannel.addChannel({
          ...this.channelForm,
        });
        if (data.code === 200) {
          this.$message.success("新增渠道成功");
          this.dialogVisible = false;
          this.getChannelList();
        }
      } finally {
        this.saving = false;
      }
    },
    copyChannel(id) {
      this.$confirm(
        "当前模型下复制渠道主记录会返回后端不支持提示，是否继续？",
        "复制渠道",
        {
          type: "warning",
        }
      ).then(async () => {
        await this.$api.getChannel.copyChannel({ id });
      });
    },
    delChannel(row) {
      this.$confirm(
        `确认删除渠道 ${row.nickname || row.id} 吗？删除后不可恢复。`,
        "删除确认",
        {
          type: "warning",
        }
      ).then(async () => {
        const data = await this.$api.getChannel.deleteChannel({ id: row.id });
        if (data.code === 200) {
          this.$message.success("删除成功");
          this.getChannelList();
        }
      });
    },
    async changeNickname(row) {
      this.$prompt("请输入新的渠道名称", "修改渠道名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: row.nickname || "",
      }).then(async ({ value }) => {
        const nickname = String(value || "").trim();
        if (!nickname) {
          this.$message.warning("渠道名称不能为空");
          return;
        }
        const data = await this.$api.getChannel.saveChannel({
          id: row.id,
          nickname,
        });
        if (data.code === 200) {
          this.$message.success("修改成功");
          this.getChannelList();
        }
      });
    },
    goDetail(id) {
      this.$router.push({
        path: "/index/channel_detail",
        query: { id },
      });
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.paginationForm.page = 1;
    },
    getSearch(form) {
      this.queryForm = form || {};
      this.paginationForm.page = 1;
      this.applyLocalFilters();
    },
  },
  created() {
    this.getChannelList();
  },
};
</script>

<style lang="less" scoped>
.channel-cell__title {
  font-weight: 600;
  color: #203864;
}

.channel-cell__sub {
  margin-top: 4px;
  font-size: 12px;
  color: #8090ac;
}

/deep/ .el-table .el-table__cell {
  padding: 8px 0;
}
</style>
